/// <reference path="../../../../typings/index.d.ts" />

module Meevo.Plugins.UsageReasons {
	angular.module("meevo.plugins.usageReasons", []);
}